import { AppType } from '@/models/enums/AppType';
import { prettifyEnumName } from '@/models/enums/EnumHelper';

// One label source for app names, shared with Licensed Apps on Location Details — the whole reason a playlist
// stores AppType rather than its own list is that both screens name the same thing the same way. Derived from
// the enum key rather than a localized string for the same reason Licensed Apps does it: these are product
// names, and a translated "Dual Display" would stop matching the checkbox the user licensed it with.
const APP_TYPE_NAMES = Object.fromEntries(
    Object.entries(AppType).map(([name, value]) => [value, prettifyEnumName(name)]),
) as Record<AppType, string>;

export const appTypeLabel = (app: AppType) => APP_TYPE_NAMES[app] ?? String(app);
